<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2019-08-20 16:56:41
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-04-03 16:23:17
 -->
<template>
	<div
		id="app"
		style="height: 100%;width: 100%;"
	>
		<router-view />
	</div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
export default {
	name: 'App',
	created() {
		// this.getOrgTypeList()
		// this.getOrgSubTypeList()
		// this.getPositionType()
		// this.getVisitedScopeType()
		// this.getVisitedScopeTypeTwo()
		// this.getPublishStatus()
		// this.getAdvertiseType()
		// this.getModuleJsonType()
		// this.getModuleSubJsonType()
		// this.getModuleSubJsonType()
		// this.getUserSexyJsonType()
		// this.getModuleTypeList()
	},
	methods: {
		getOrgTypeList() {
			this.$apiData.orgTypeList().then((res) => {
				if (res && res.data.code == '0000') {
					this.setOrgTypeList(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getOrgSubTypeList() {
			this.$apiData.orgSubTypeList().then((res) => {
				if (res && res.data.code == '0000') {
					this.setOrgSubTypeList(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getPositionType() {
			this.$apiData.positionType().then((res) => {
				if (res && res.data.code == '0000') {
					this.setPositionType(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getVisitedScopeType() {
			this.$apiData.visitedScopeType().then((res) => {
				if (res && res.data.code == '0000') {
					this.setVisitedScopeType(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getVisitedScopeTypeTwo() {
			this.$apiData.visitedScopeTypeTwo().then((res) => {
				if (res && res.data.code == '0000') {
					this.setVisitedScopeTypeTwo(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getPublishStatus() {
			this.$apiData.publishStatus().then((res) => {
				if (res && res.data.code == '0000') {
					this.setPublishStatus(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getAdvertiseType() {
			this.$apiData.advertiseType().then((res) => {
				if (res && res.data.code == '0000') {
					this.setAdvertiseType(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getModuleJsonType() {
			this.$apiData.moduleJsonType().then((res) => {
				if (res && res.data.code == '0000') {
					this.setModuleJsonType(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getModuleSubJsonType() {
			this.$apiData.moduleSubJsonType().then((res) => {
				if (res && res.data.code == '0000') {
					this.setModuleSubJsonType(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getUserIdJsonType() {
			this.$apiData.UserIdJsonType().then((res) => {
				if (res && res.data.code == '0000') {
					this.setUserIdJsonType(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getUserSexyJsonType() {
			this.$apiData.userSexyJsonType().then((res) => {
				if (res && res.data.code == '0000') {
					this.setUserSexyJsonType(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		getModuleTypeList() {
			this.$apiData.moduleTypeList().then((res) => {
				if (res && res.data.code == '0000') {
					this.setModuleTypeList(res.data.data.itemList)
				} else {
					res && this.$message.error((res && res.data.msg) || '请求出错了！')
				}
			})
		},
		...mapMutations([
			'getOrgTypeList',
			'getOrgSubTypeList',
			'getPositionType',
			'getVisitedScopeType',
			'getVisitedScopeTypeTwo',
			'getPublishStatus',
			'getAdvertiseType',
			'getModuleJsonType',
			'getModuleSubJsonType',
			'getUserIdJsonType',
			'getUserSexyJsonType',
			'getModuleTypeList',
		]),
	},
}
</script>
<style lang='scss'>
.el-table th.gutter {
	display: table-cell !important;
}
.el-table--border th.gutter:last-of-type {
	display: block !important;
	width: 17px !important;
}
tbody .el-button {
	width: 100%;
	display: block;
	margin: 0 !important;
	text-align: center;
	padding: 4px;
}
#app {
	height: 100%;
}
.search-box {
	padding: 20px;
	padding-bottom: 0px;
	background-color: #fff;
	.search-btn {
		margin-left: 20px;
		margin-bottom: 10px;
	}
	.content {
		text-align: right;
	}
	.search {
		display: inline-block;
		margin-bottom: 10px;
		margin-left: 10px;
	}
	// width: 100%;
	.title {
		margin-bottom: 20px;
	}
}
.form-content {
	padding: 20px;
	padding-top: 0;
	background-color: #fff;
	// margin-top: 20px;
}
.search-module {
	display: inline-block;
	margin: 0 10px 20px 10px;

	.box {
		position: relative;
		display: inline-block;
	}

	.btn {
		cursor: pointer;
		text-align: center;
		display: inline-block;
		position: absolute;
		top: 0;
		right: 0;
		margin-right: 30px;
		padding: 0;
		margin-top: 8px;
		border: none;
		color: #2d8cf0;
	}
}
.el-form-item__content .el-input,
.el-radio-group {
	width: 180px !important;
}
.annou_create .el-radio-group {
	width: 100% !important;
}
.annou_create .el-input {
	width: 220px !important;
}
.el-radio {
	margin-right: 20px;
}
.el-form-item {
	margin-left: 18px !important;
}
.risk_table .el-table__empty-block {
	width: auto !important;
}
.risk_updata_table .cell {
	text-align: center !important;
}

.el-checkbox.is-bordered + .el-checkbox.is-bordered {
	margin-left: 0px !important;
}
.custom-tree-node > span {
	margin-right: 10px;
}

.role_table .el-table__empty-block {
	width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue